module.exports = __webpack_public_path__ + "3708994bdca38cd8dbea509f233f3cf4.jpg";